export default __webpack_public_path__ + "static/media/Flaticon_1.3eb59613.woff2";